module.exports = "../images/icons/admin/icon-edit.svg";